module.exports = __webpack_public_path__ + "media/control_acceso/peatonal_manual_labeled-d3703c09.png";